import { useAuthStore } from '@sunrise-ui/primitives';
import { useMemo } from 'react';
import { useGetTicketsByEventId } from '../queries/tickets';

/**
 * Hook to get the current user's active ticket for a specific event.
 */
export function useUserEventTicket(eventId?: string, communityId?: string) {
  // TODO: There is a BE bug I think meaning the normal temporal endpoint doesn't work here
  const { data: eventTickets, isLoading: isLoadingTickets } =
    useGetTicketsByEventId({ eventId, communityId });
  const { currentUserId } = useAuthStore();

  const userTicket = useMemo(() => {
    if (!eventTickets || !currentUserId) return null;

    return eventTickets.find(
      (ticket) => ticket.is_active && ticket.user_id === currentUserId,
    );
  }, [eventTickets, currentUserId]);

  return {
    userTicket,
    isLoadingTickets,
  };
}
